/* eslint-disable ember/no-new-mixins */
import { alias } from '@ember/object/computed';
import Mixin from '@ember/object/mixin';
import { computed } from '@ember/object';
import { isPresent } from '@ember/utils';
import moment from 'moment';

export default Mixin.create({
  dob: alias('model.dob'),

  ageYears: computed('dob', function () {
    let dob = this.dob;

    if (isPresent(dob)) {
      return moment().diff(dob, 'years');
    }

    return '';
  }),

  ageMonths: computed('dob', function () {
    let dob = this.dob;

    if (isPresent(dob)) {
      return moment().diff(dob, 'months') % 12;
    }

    return '';
  }),
});
